import { ColumnConfig } from '@/components/table/Table';
import { renderSlotRange, renderSlotStatus } from '../renderers';

export const agendasTableColumns: ColumnConfig[] = [
  { label: 'Estado', field: 'status', render: renderSlotStatus },
  { label: 'Fecha', field: 'dateOpen' },
  { label: 'Desde - Hasta', field: 'slots', render: renderSlotRange },
];

export const slotsTableColumns: ColumnConfig[] = [
  { label: 'Horas', field: 'slots' },
];
